export const promiseQueueHelper = (promises, concurrentCount = 1) => {
  const queue = promises;
  let ongoingCount = 0;
  let failed = false;

  const runItem = (item, resolve, reject) => {
    ongoingCount++;

    item()
      .then(() => {
        ongoingCount--;
        resolve();
      })
      .catch((err) => {
        failed = true;
        ongoingCount--;
        reject(err);
      });
  };

  return new Promise((resolve, reject) => {
    const next = () => {
      if (failed) return;

      if (ongoingCount < concurrentCount && queue.length) {
        const item = queue.shift();
        runItem(item, next, reject);
      } else if (ongoingCount === 0 && queue.length === 0) {
        resolve();
      }
    };

    for (let i = 0; i < concurrentCount && i < queue.length; i++) {
      next();
    }
  });
};
